import React from 'react';
import ReactTooltip from 'react-tooltip';

export class VoyageActivityRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.elRef = React.createRef();
    }

    tooltipDelay = 400;

    clearTooltipTimer = () => {
        if (!this.tooltipTimer) {
            return;
        }
        window.clearTimeout(this.tooltipTimer);
        this.tooltipTimer = undefined;
    };

    render() {
        let displayValue = this.props.data.voyageActivity;

        if (displayValue) {
            displayValue = displayValue.toUpperCase();
        }

        const rowIndex = `${this.props.rowIndex}`;

        const id = `${this.props.context.gridId}-voyage-activity`;

        return (
            <div
                ref={this.elRef}
                style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
                data-tip={rowIndex}
                data-for={id}
                onMouseEnter={() => {
                    if (this.tooltipTimer) {
                        return; // prevent double triggering problem on some browsers
                    }

                    this.tooltipTimer = setTimeout(() => {
                        ReactTooltip.show(this.elRef.current);
                        this.clearTooltipTimer();
                    }, this.tooltipDelay);
                }}
                onMouseLeave={() => {
                    this.clearTooltipTimer();
                    ReactTooltip.hide(this.elRef.current);
                }}
            >
                {displayValue}
            </div>
        );
    }
}

export default VoyageActivityRenderer;
